import { styled } from "@mui/material/styles";

export const ItemsAndMaterialsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const RoomName = styled("span")(() => ({
  color: "#475467",
  font: "600 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const RoomCardsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  paddingTop: "12px",
}));

export const RoomContentCard = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  padding: "8px 16px",
  alignSelf: "stretch",
}));

export const RoomContentCardTitle = styled("div", {
  shouldForwardProp: (props) => props !== "color",
})(({ color }: { color?: string }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color,
}));

export const ItemsWrapper = styled("div")(() => ({
  paddingTop: 12,
}));

export const ItemDescription = styled("span")(() => ({
  font: "600 16px Manrope",
  lineHeight: "24px",
}));

export const ItemInfo = styled("span")(() => ({
  color: "#475467",
  font: "400 14px Manrope",
  lineHeight: "20px",
  paddingLeft: "4px",
}));

export const ItemInfoText = styled("span")(() => ({
  color: "#475467",
  font: "600 14px Manrope",
  lineHeight: "20px",
}));

export const ItemInfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "stretch",
  paddingTop: "8px",
  gap: "4px",
}));

export const RoomInfoHeader = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignSelf: "stretch",
  alignItems: "center",
}));

export const RoomInfoText = styled("span")(() => ({
  color: "#475467",
  font: "400 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const RoomItemsInfo = styled("ul")(() => ({
  listStyle: "none",
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  "& li": {
    margin: 0,
    position: "relative",
    "&:not(:last-child)": {
      paddingRight: "12px",
      marginRight: "8px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: 4,
        height: 4,
        top: "45%",
        right: 0,
        backgroundColor: "#475467",
        borderRadius: 4,
      },
    },
  },
}));
